import { Fonts, Colors } from '../../../config/theme';
import styled from 'styled-components';
export const ExpandedOrderWrapper = styled.div`
  border-width: 2px 2px 2px 7px;
  border-style: solid;
  border-color: ${Colors.greenMain};
  border-radius: 5px;
  .item-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    .content {
      display: flex;
      justify-content: start;
      gap: 20px;
      span {
        display: flex;
        margin-top: auto;
        margin-bottom: auto;
      }
    }
  }
  .table {
    ${'' /* background: rgba(220, 238, 221, 0.5); */}

    tr {
      width: 100%;
      text-align: center;
      th {
        font-family: ${Fonts.secondary};
        font-weight: 700;
        font-size: 13px;
        color: var(--secondary-color);
        width: 20%;
      }
      td {
        font-family: ${Fonts.secondary};
        font-weight: 400;
        font-size: 13px;
        width: 20%;
      }
    }
  }

  .goto {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    cursor: pointer;
    color: var(--secondary-color);

    img {
      width: 60%;
      max-height: 100px;
    }
  }
`;

export const ArchivedOrdersWrapper = styled.div`
  margin-bottom: 100px;
  .tabs {
    margin-top: auto;
    margin-bottom: auto;
  }

  .archive-content {
    #orders-tab-container-tab-all {
      padding: 0.5rem;
      letter-spacing: normal;
    }
  }

  .order-item-card {
    box-sizing: border-box;
    background: var(--white-color);
    border-bottom: 1px solid var(--secondary-color);
  }
  div {
    span {
      display: flex;
      align-items: center;
    }
    span.title {
      font-size: 15px;
      font-weight: 500;
      color: var(--dark-color);
    }
    span.value {
      font-size: 18px;
      font-weight: bold;
      .qty {
        color: var(--dark-grey);
      }
      .amount {
        color: var(--dark-color);
      }
    }
    span.attr-value {
      color: var(--theme-clr);
      font-weight: bold;
    }
  }

  .item-container {
    display: flex;
    flex-wrap: wrap;
  }

  .item {
    display: flex;
    flex-direction: column;
    margin-left: 10px; /* adjust as needed */
    margin-bottom: 20px; /* adjust as needed */
    font-family: 'poppins';

    .item-element-name {
      color: var(--dark-grey);
    }
  }

  .item-element {
    min-height: 50px;
  }
  .order-items-title {
    color: var(--dark-grey);
  }
`;

export const FilterBtnsStyled = styled.div`
  padding: 0.5rem 0rem 0.5rem 1rem;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: center;
  grid-gap: 10px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #4c6870;

  .css-1u9des2-indicatorSeparator {
    display: none;
  }

  .css-1jqq78o-placeholder {
    color: var(--secondary-color);
  }

  .filter {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
`;
